module.exports = __webpack_public_path__ + "app/payment/list-payments-VhOlX5k5.html";